import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayOnMultiSelectPipe'
})
export class DisplayOnMultiSelectPipe implements PipeTransform {

  transform(value: any): any {
    let output = value;
    if (output.length > 22) {
      return output.substring(0, 22) + "...";
    } else {
      return output;
    }
  }

}
